import axios from "axios";
import { getApiBaseUrl } from "./apiConfig";

const boletaApi = axios.create({
  baseURL: getApiBaseUrl(),
});

function getBearerToken() {
  try {
    const company = localStorage.getItem("userDetails");
    if (company) {
      const p = JSON.parse(company);
      const t = p.accessToken || p.idToken;
      if (t) return t;
    }
    const affiliate = localStorage.getItem("userDetailsAfiliate");
    if (affiliate) {
      const p = JSON.parse(affiliate);
      return p.accessToken || p.idToken;
    }
  } catch {
    return null;
  }
  return null;
}

boletaApi.interceptors.request.use((config) => {
  const token = getBearerToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }
  return config;
});

export default boletaApi;
